import { render, staticRenderFns } from "./SmbAlert.vue?vue&type=template&id=5215969c&scoped=true&"
import script from "./SmbAlert.vue?vue&type=script&lang=ts&"
export * from "./SmbAlert.vue?vue&type=script&lang=ts&"
import style0 from "./SmbAlert.scss?vue&type=style&index=0&id=5215969c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5215969c",
  null
  
)

export default component.exports